import { Actions, ofType, createEffect } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { PaymentHistoryService } from '@features/account/modules/payment/services/payment-history/payment-history.service';
import { CreditHistoryService } from '@features/account/modules/payment/services/credit-history/credit-history.service';
import { fromPaymentActions } from './table.actions';

@Injectable()
export class PaymentEffects {
  constructor(
    private _paymentHistoryService: PaymentHistoryService,
    private _creditHistoryService: CreditHistoryService,
    private _actions$: Actions
  ) {}

  getPaymentHistory$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(fromPaymentActions.getPaymentHistory),
        switchMap(() => this._paymentHistoryService.listPaymentHistory$())
      ),
    { dispatch: false }
  );

  getCreditHistory$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(fromPaymentActions.getCreditHistory),
        switchMap(() => this._creditHistoryService.listCreditHistory$())
      ),
    { dispatch: false }
  );
}
